export default __webpack_public_path__ + "static/media/full-page-bg.10c3edc2.jpg";